let EOUTAH = (function ($) {
  return {
    init: function () {
      const self = this;

      this.instagram();
      this.heroSlider();
      this.menu();
      this.eventTab();
      this.videoYoutube();
      this.videoSlider();
      this.stepEvents();
      this.searchMembers();
    },
    homeSlider: function (id) {
      let widget = id ? $('[data-id="' + id + '"]') : $(".slider-home");
      let slider = widget.find("[data-slider]");
      let slides = slider.find("[data-slider-slide]");
      let slidesLength = slides.length;

      if (slidesLength > 0 && !slider.hasClass("slick-initialized")) {
        slider.slick({
          infinite: false,
          swipeToSlide: true,
          slidesToShow: 1,
          arrows: false,
          dots: true,
        });
      }
    },

    player: [],
    videoYoutube: function () {
      var videoLength = $("[data-video-id]").length;
      
      if (videoLength > 0) {
        let _this = this;
        var tag = document.createElement("script");

        tag.src = window.location.protocol + "//www.youtube.com/player_api";
        var firstScriptTag = document.getElementsByTagName("script")[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

        function onPlayerReady(event) {
          event.target.playVideo();
        }

        _this.player = [];
        $("[data-video-id]").on("click", function () {
          var videoId = $(this).data("video-id");
          
          _this.player.push({
            id: videoId,
            player: new YT.Player("yt-video-" + videoId, {
              videoId: videoId,
              autoplay: 1,
              host: `${window.location.protocol}//www.youtube.com`,
              events: {
                onReady: onPlayerReady,
              },
            }),

          });
          $(this).parent().addClass("video-active");
        });
      }
    },

    stepEvents: function(){
     $("[data-step-id").on("click", function(){
       var stepSelect = $(this).data("step-id");

       $('[data-step-selected='+ stepSelect +']')
       .addClass("step-active");
       
      console.log("step",stepSelect);
     })
    },

    //Video Slider
    videoSlider: function (id) {
      let _this = this;
      let widget = id
        ? $('[data-id="' + id + '"]')
        : $(".video-slider__slider");
      let slider = widget.find("[data-slider]");
      let slides = slider.find("[data-slider-slide]");
      let slidesLength = slides.length;

      if (slidesLength > 0 && !slider.hasClass("slick-initialized")) {
        slider
          .slick({
            infinite: true,
            swipeToSlide: true,
            slidesToShow: 1,
            arrows: true,
            dots: false,
            prevArrow: $(".prev"),
            nextArrow: $(".next"),
          })

          .on("beforeChange", function (e, s, c, n) {
            let videoId = $(s.$slides.get(c))
              .find("[data-video-id]")
              .attr("data-video-id");
            var video = _this.player.find((item) => {
              return item.id === videoId;
            });

            if (video) video.player.pauseVideo();
            $(this)
              .parent()
              .find("[data-slide-number]")
              .text(n + 1 < 10 ? "0" + (n + 1) : n + 1);
          });
      } 

    },

    testimonialsSlider: function (id) {
      let widget = id ? $('[data-id="' + id + '"]') : $(".testimonials");
      let slider = widget.find("[data-slider]");
      let slides = slider.find("[data-slider-slide]");
      let slidesLength = slides.length;

      if (slidesLength > 0 && !slider.hasClass("slick-initialized")) {
        slider
          .slick({
            infinite: true,
            swipeToSlide: true,
            slidesToShow: 1,
            arrows: true,
            dots: false,
            prevArrow: $(".prev"),
            nextArrow: $(".next"),
          })
          .on("beforeChange", function (e, s, c, n) {
            console.log(n);

            $(this)
              .parent()
              .find("[data-slide-number]")
              .text(n + 1 < 10 ? "0" + (n + 1) : n + 1);
          });
      }
    },
    instagram: function (id) {
      let widget = id ? $('[data-id="' + id + '"]') : $(".instagram");
      let slider = widget.find("[data-slider]");
      let slides = slider.find("[data-slider-slide]");
      let slidesLength = slides.length;

        if (slidesLength > 0 && !slider.hasClass("slick-initialized")) {
          slider.slick({
            infinite: true,
            swipeToSlide: true,
            arrows: false,
            dots: false,
            slidesToShow: 8
          });
        }
    },

    //Slider Profile
    sliderProfile: function (id) {
      let widget = id ? $('[data-id="' + id + '"]') : $(".slider-profile");
      let slider = widget.find("[data-slider]");
      let slides = slider.find("[data-slider-slide]");
      let slidesLength = slides.length;

      if (slidesLength > 0 && !slider.hasClass("slick-initialized")) {
        slider.slick({
          infinite: false,
          swipeToSlide: true,
          slidesToShow: 3,
          arrows: false,
          dots: false,
          variableWidth: true,
        });
      }
    },

    //Slider Hero
    heroSlider: function (id) {
      let widget = id ? $('[data-id="' + id + '"]') : $(".hero__slider");
      let slider = widget.find("[data-slider]");
      let slides = slider.find("[data-slider-slide]");
      let slidesLength = slides.length;

      console.log('-->', {widget,
        slider,
        slides,
        slidesLength});

      if (slidesLength > 0 && !slider.hasClass("slick-initialized")) {
        slider
          .slick({
            infinite: true,
            swipeToSlide: true,
            slidesToShow: 1,
            arrows: true,
            dots: false,
            prevArrow: $(".prev"),
            nextArrow: $(".next"),
          })
          .on("beforeChange", function (e, s, c, n) {
            console.log(n);

            $(this)
              .parent()
              .find("[data-slide-number]")
              .text(n + 1 < 10 ? "0" + (n + 1) : n + 1);
          });
      }
    },
    menu: function (id) {
      $("[data-menu]").on("click", function () {
        $(".site-header").toggleClass("opened");
        $(".site-header__button").toggleClass("opened");
        $(".site-header__menu").toggleClass("opened");
        $(".site-header__shadow").toggleClass("opened");
      });
    },
    subMenuToggle: function () {
      $(".menu-item-has-children > button.arrow").on("click", function (e) {
        var width = $(window).width();

        if (width < 768) {
          e.preventDefault();
          $(this).parent().find(".sub-menu").first().slideToggle(500);
        }
      });

      var resizeFunction = function () {
        var width = $(window).width();

        if (width > 767) $(".sub-menu").removeAttr("style");
      };

      var timeout = null;
      $(window).on("resize", function () {
        if (timeout) clearTimeout(timeout);

        timeout = setTimeout(resizeFunction, 50);
      });
    },
    eventTab: function () {
      $("[data-tab-id]").on("click", function () {
        const id = $(this).attr("[data-tab-id]");
        $(this).parents(".tabs").find(".active[data-tab-container]").fadeOut();
        $(this)
          .parents(".tabs")
          .find('[data-tab-container="' + id + '"]')
          .fadeIn(500, function () {
            $(this).addClass("active");
          });
      });
    },
    storeLocator: function (id) {},
    searchMembers: function () {
      $('#search-members').on('input', function() {
        var inputValue = $(this).val().toUpperCase();
        $('.member-list__content').each(function(i, el) {
          if ($(el).text().toUpperCase().indexOf(inputValue) == -1) {
            $(el).hide();
          } else {
            $(el).show();
          }
        })
      });
    }
  };
})(jQuery);

(function ($) {
  $(window).on("elementor/frontend/init", function () {
    elementorFrontend.hooks.addAction(
      "frontend/element_ready/eo-utah-slider.default",
      function ($scope) {
        EOUTAH.homeSlider($scope.context.dataset.id);
      }
    );
    elementorFrontend.hooks.addAction(
      "frontend/element_ready/eo-utah-testimonials.default",
      function ($scope) {
        EOUTAH.testimonialsSlider($scope.context.dataset.id);
      }
    );
    elementorFrontend.hooks.addAction(
      "frontend/element_ready/eo-utah-instagram.default",
      function ($scope) {
        EOUTAH.instagram($scope.context.dataset.id);
      }
    );
    elementorFrontend.hooks.addAction(
      "frontend/element_ready/eo-utah-slider-profile.default",
      function ($scope) {
        EOUTAH.sliderProfile($scope.context.dataset.id);
      }
    );
    elementorFrontend.hooks.addAction(
      "frontend/element_ready/eo-utah-hero-inner.default",
      function ($scope) {
        EOUTAH.heroSlider($scope.context.dataset.id);
      }
    );
    elementorFrontend.hooks.addAction(
      "frontend/element_ready/eo-utah-video-slider-events.default",
      function ($scope) {
        EOUTAH.videoSlider($scope.context.dataset.id);
      }
    );

  });

  $(EOUTAH.init());
})(jQuery);
